// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3294":"075dd50989229bd5","3634":"a4e417974e3bcf78","5608":"1033db3abffb7c65","6793":"f57464ca23fa9330","9014":"c58b6a6dee1069c8","9334":"e0f9d358b7e6b9d6","9630":"a86adef5bd153486","9650":"ff2ca2822ca49418"}[chunkId] + ".js";
};